/** Labels for print_lab job types (stored as printType: bw | color | copy | scan | customer-ream). */
export function printServiceLabel(printType) {
  switch (printType) {
    case 'color':
      return 'Colored print';
    case 'bw':
      return 'Black & white print';
    case 'copy':
      return 'Photocopy';
    case 'scan':
      return 'Scan';
    case 'customer-ream':
      return 'Customer with own ream';
    default:
      return printType || '—';
  }
}
